import { Component, Input, OnInit } from '@angular/core';
import { ElementType } from 'src/app/_objects/element-type';
import { ReportVisualEvents } from 'src/app/_objects/report-visual-events';
import { Notifier, ReportTemplateDesignService } from 'src/app/_services/report-template-design.service';

@Component({
    selector: 'app-visual-events',
    templateUrl: './visual-events.component.html',
    styleUrls: ['./visual-events.component.scss'],
    standalone: false
})
export class VisualEventsComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public visualEventsKey: string;
  @Input() public elementLocation: string;

  public notifier: Notifier;
  public reportVisualEvents: ReportVisualEvents;
  public resizeMarkerSize: number;
  public resizing: boolean;
  constructor(public designService: ReportTemplateDesignService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: 'visual-events.component',
      ids: { pageId: this.pageKey, elementId: this.visualEventsKey }
    };
    this.reportVisualEvents = this.designService.getVisualEvents(this.visualEventsKey);
    const elementNavigator = this.designService.navigatorElements
    .filter((x) => x.pageKey === this.pageKey)[0]
    .elementsDetails.filter((y) => y.location === this.elementLocation)[0]
      .elements;

    elementNavigator.filter(x => x.elementName === ElementType.VisualEvents).length > 0
      ? elementNavigator[0].elementData.push({
          id: this.visualEventsKey,
          page: this.pageKey,
          name: this.reportVisualEvents.titleText,
        })
      : elementNavigator.push({
          elementName: ElementType.VisualEvents,
          isVisible: false,
          elementData: [
            {
              id: this.visualEventsKey,
              page: this.pageKey,
              name: this.reportVisualEvents.titleText,
            },
          ],
        });
  }

  public onClick(event: MouseEvent) {
    if (this.reportVisualEvents.isSelectable) {
      this.designService.notifySelectElement(this.notifier, this.visualEventsKey, event.ctrlKey);
      event.stopPropagation();
    }
  }

  public getStyles(reportVisualEvents: ReportVisualEvents): object {
    return {
      width: reportVisualEvents.width,
      height: reportVisualEvents.itemContainerHeight,
      fontSize: reportVisualEvents.fontSize,
      fontFamily: reportVisualEvents.fontFamily,
      border: `${reportVisualEvents.borderWidth} ${reportVisualEvents.borderStyle} ${reportVisualEvents.borderColor}`,
      padding: `${reportVisualEvents.itemMargin}mm`
    };
  }

  public getContainerStyle(reportVisualEvents: ReportVisualEvents): object {
    return {
      top: reportVisualEvents.top,
      left: reportVisualEvents.left,
      width: reportVisualEvents.width,
      height: reportVisualEvents.height
    };
  }

  public getItemStyles(reportVisualEvents: ReportVisualEvents): object {
    return {
      width: reportVisualEvents.width,
      height: reportVisualEvents.height,
      border: `${reportVisualEvents.borderWidth} ${reportVisualEvents.borderStyle} ${reportVisualEvents.borderColor}`,
      margin: reportVisualEvents.itemMargin
    };
  }

}
